import { normalizeKeysym } from "./normalize-keysym";

/**
 * Installs a normalization wrapper on an RFB instance's sendKey so every
 * outgoing key event - from noVNC's internal key handling, sendKeyToRemote and
 * the CapsLock sync - is normalized before it reaches the binary RFB channel.
 * Silently no-ops when the instance has no sendKey function.
 *
 * The wrapper preserves the full (keysym, code, down) signature and keeps the
 * original sendKey bound to the RFB instance, which it needs to read internal
 * state such as this._rfbConnectionState or this._viewOnly.
 *
 * @param rfb - the RFB instance to wrap
 */
export const installSendKeyNormalization = (
  rfb: { sendKey?: (keysym: number, code?: string, down?: boolean) => unknown },
): void => {
  if (typeof rfb.sendKey !== "function") return;

  const original = rfb.sendKey;

  rfb.sendKey = (keysym: number, code?: string, down?: boolean) =>
    original.call(rfb, normalizeKeysym(keysym), code, down);
};